import CourseModule from "./CourseModule";

const CourseLevel = ({ level, icon, isOpen, onClick, modules, loading }) => {
  return (
    <>
      <div
        className={`course-level-strip ${level.key}`}
        onClick={onClick}
      >
        <img src={icon} alt={level.title} />
        <h2>{level.title} →</h2>
      </div>

      {isOpen && (
        <div className="module-list">
          {loading && <p style={{ padding: 20 }}>Loading...</p>}

          {!loading && modules.length === 0 && (
            <p style={{ padding: 20 }}>No modules found</p>
          )}

          {!loading &&
            modules.map((mod, i) => (
              <CourseModule
                key={i}
                module={mod}
                level={level.title}
              />
            ))}
        </div>
      )}
    </>
  );
};

export default CourseLevel;
